export default __webpack_public_path__ + "static/text-hero-import-3a1dc87a4b692c4c99683993b11bd32c.png";